import { render, staticRenderFns } from "./ReportFarmerUnsuccessfulSummaries.vue?vue&type=template&id=4080f3ce&"
import script from "./ReportFarmerUnsuccessfulSummaries.vue?vue&type=script&lang=js&"
export * from "./ReportFarmerUnsuccessfulSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports